<div class="m-3 tw-pt-14 md:tw-pt-0">
  <nb-card>
    <nb-card-header>
      <div class="d-flex justify-content-between align-items-center">
        <button ghost nbButton status="primary" (click)="navigateBack()"><mat-icon>arrow_left</mat-icon>Back</button>

        <div class="d-flex justify-content-center flex-grow-1" *ngIf="auth.canEditOrganization">
          <nb-card class="icon-wrapper d-flex align-items-center justify-content-center m-0" [class.active]="activeRoute() === 'organization'" [routerLink]="['organization']">
            <nb-card-body class="d-flex align-items-center justify-content-center flex-column">
              <mat-icon>groups</mat-icon>
              <p>Organization</p>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
    </nb-card-header>
    <nb-card-body>
      <router-outlet></router-outlet>
    </nb-card-body>
  </nb-card>
</div>
